// import React, { Component } from 'react'
// import { toast } from 'react-toastify';
// import {
//     sendContactForm,
//     validateEmail,
//     validatePhone,
//     validateRequired,
//     rateLimiter,
//     handleApiError,
//     getSuccessMessage
// } from '../../utils/api';


// class ContactForm extends Component {


//     state = {
//         name: '',
//         email: '',
//         phone: '',
//         propertyType: '',
//         message: '',
//         error: {}
//     }


//     changeHandler = (e) => {
//         const error = this.state.error;
//         error[e.target.name] = ''

//         this.setState({
//             [e.target.name]: e.target.value,
//             error
//         })
//     }

//     validateForm = () => {
//         const { name, email, phone, propertyType } = this.state;
//         const errors = {};

//         if (!validateRequired(name)) {
//             errors.name = "Please enter your name";
//         }

//         if (!validateEmail(email)) {
//             errors.email = "Please enter a valid email";
//         }

//         if (!validatePhone(phone)) {
//             errors.phone = "Please enter a valid phone number";
//         }

//         if (!validateRequired(propertyType)) {
//             errors.propertyType = "Please select a property type";
//         }

//         return errors;
//     }

//     subimtHandler = async (e) => {
//         e.preventDefault();

//         // Validate form
//         const errors = this.validateForm();
//         if (Object.keys(errors).length > 0) {
//             this.setState({ error: errors });
//             return;
//         }

//         // Check rate limiting
//         if (!rateLimiter.canMakeRequest('/api/send-contact-form')) {
//             toast.error('Too many requests. Please wait a moment and try again.');
//             return;
//         }

//         const { name, email, phone, propertyType, message } = this.state;

//         try {
//             // Send contact form via API
//             const formData = {
//                 name,
//                 email,
//                 phone,
//                 propertyType,
//                 message
//             };

//             const response = await sendContactForm(formData);

//             if (response.success) {
//                 // Reset form
//                 this.setState({
//                     name: '',
//                     email: '',
//                     phone: '',
//                     propertyType: '',
//                     message: '',
//                     error: {}
//                 });

//                 // Show success toast
//                 toast.success(getSuccessMessage('contact'));
//             } else {
//                 throw new Error(response.message || 'Failed to send contact form');
//             }

//         } catch (error) {
//             const errorMessage = handleApiError(error, 'contact');
//             toast.error(errorMessage);
//         }
//     }

//     render() {
//         const { name, email, phone, propertyType, message, error } = this.state;

//         return (
//             <form onSubmit={this.subimtHandler} className="form">
//                 <div className="row justify-content-center">
//                     <div className="col-lg-6 col-md-6 col-12">
//                         <div className="form-field">
//                             <input value={name} onChange={this.changeHandler} type="text" name="name" placeholder="Full Name" />
//                             <p>{error.name ? error.name : ''}</p>
//                         </div>
//                     </div>
//                     <div className="col-lg-6 col-md-6 col-12">
//                         <div className="form-field">
//                             <input onChange={this.changeHandler} value={email} type="email" name="email" placeholder="Email Address" />
//                             <p>{error.email ? error.email : ''}</p>
//                         </div>
//                     </div>
//                     <div className="col-lg-6 col-md-6 col-12">
//                         <div className="form-field">
//                             <input onChange={this.changeHandler} value={phone} type="tel" name="phone" placeholder="Phone Number" />
//                             <p>{error.phone ? error.phone : ''}</p>
//                         </div>
//                     </div>
//                     <div className="col-lg-6 col-md-6 col-12">
//                         <div className="form-field">
//                             <select className="form-control" onChange={this.changeHandler} value={propertyType} name="propertyType">
//                                 <option value="">Select Property Type</option>
//                                 <option value="Studio">Studio</option>
//                                 <option value="1 Bed">1 Bed</option>
//                                 <option value="2 Bed">2 Bed</option>
//                             </select>
//                             <p>{error.propertyType ? error.propertyType : ''}</p>
//                         </div>
//                     </div>
//                     <div className="col-lg-12">
//                         <div className="form-field">
//                             <textarea name="message" placeholder="Additional Message (Optional)" value={message} onChange={this.changeHandler}></textarea>
//                         </div>
//                     </div>
//                     <div className="col-lg-12">
//                         <div className="form-submit">
//                             <button type="submit" className="theme-btn">Send Inquiry</button>
//                         </div>
//                     </div>
//                 </div>
//             </form>
//         )
//     }

// }
// export default ContactForm;
















import React, { Component } from "react";
import { toast } from "react-toastify";
import { sendContactForm } from "../../api/Contact"; // updated import

class ContactForm extends Component {
  state = {
    name: "",
    email: "",
    phone: "",
    propertyType: "",
    message: "",
    error: {},
  };

  changeHandler = (e) => {
    const error = this.state.error;
    error[e.target.name] = "";
    this.setState({
      [e.target.name]: e.target.value,
      error,
    });
  };

  validateForm = () => {
    const { name, email, phone, propertyType } = this.state;
    const errors = {};

    if (!name.trim()) errors.name = "Please enter your name";
    if (!email.trim() || !/\S+@\S+\.\S+/.test(email))
      errors.email = "Please enter a valid email";
    if (!phone.trim() || !/^\d{7,15}$/.test(phone))
      errors.phone = "Please enter a valid phone number";
    if (!propertyType.trim()) errors.propertyType = "Please select a property type";

    return errors;
  };

  submitHandler = async (e) => {
    e.preventDefault();

    const errors = this.validateForm();
    if (Object.keys(errors).length > 0) {
      this.setState({ error: errors });
      return;
    }

    const { name, email, phone, propertyType, message } = this.state;

    try {
      const formData = { name, email, phone, propertyType, message };
      const response = await sendContactForm(formData);

      if (response.success) {
        toast.success("Your message has been sent successfully!");

        this.setState({
          name: "",
          email: "",
          phone: "",
          propertyType: "",
          message: "",
          error: {},
        });
      } else {
        toast.error(response.message || "Failed to send contact form");
      }
    } catch (err) {
      toast.error("Something went wrong. Please try again.");
    }
  };

  render() {
    const { name, email, phone, propertyType, message, error } = this.state;

    return (
      <form onSubmit={this.submitHandler} className="form">
        <div className="row justify-content-center">
          <div className="col-lg-6 col-md-6 col-12">
            <div className="form-field">
              <input
                type="text"
                name="name"
                value={name}
                placeholder="Full Name"
                onChange={this.changeHandler}
              />
              <p>{error.name || ""}</p>
            </div>
          </div>

          <div className="col-lg-6 col-md-6 col-12">
            <div className="form-field">
              <input
                type="email"
                name="email"
                value={email}
                placeholder="Email Address"
                onChange={this.changeHandler}
              />
              <p>{error.email || ""}</p>
            </div>
          </div>

          <div className="col-lg-6 col-md-6 col-12">
            <div className="form-field">
              <input
                type="tel"
                name="phone"
                value={phone}
                placeholder="Phone Number"
                onChange={this.changeHandler}
              />
              <p>{error.phone || ""}</p>
            </div>
          </div>

          <div className="col-lg-6 col-md-6 col-12">
            <div className="form-field">
              <select
                name="propertyType"
                value={propertyType}
                onChange={this.changeHandler}
                className="form-control"
              >
                <option value="">Select Property Type</option>
                <option value="Studio">Studio</option>
                <option value="1 Bed">1 Bed</option>
                <option value="2 Bed">2 Bed</option>
              </select>
              <p>{error.propertyType || ""}</p>
            </div>
          </div>

          <div className="col-lg-12">
            <div className="form-field">
              <textarea
                name="message"
                placeholder="Additional Message (Optional)"
                value={message}
                onChange={this.changeHandler}
              ></textarea>
            </div>
          </div>

          <div className="col-lg-12">
            <div className="form-submit">
              <button type="submit" className="theme-btn">
                Send Inquiry
              </button>
            </div>
          </div>
        </div>
      </form>
    );
  }
}

export default ContactForm;
